import React from 'react';

import { ApiClient } from '@klokhuis/core/ApiClient';
import { FeatureFlags } from '@klokhuis/core/FeatureFlags/types';
import { AuthContext } from '@klokhuis/core/Auth/AuthContext';

import { initRudderstackAnalytics } from '../Analytics/initAnalytics';

import { AppServicesContext } from './AppServicesContext';
import { IAppServices } from './types';

export const AppServicesProvider = ({
  children,
  featureFlags,
}: {
  children: React.ReactNode;
  featureFlags: FeatureFlags;
}) => {
  const auth = AuthContext.useContext();

  const apiClient = React.useMemo(() => {
    const instance = new ApiClient();

    // Set up authorization header getter
    instance.withAuthorizationHeaderGetter(() => {
      if (auth.accessToken) {
        return `Bearer ${auth.accessToken}`;
      }
      return undefined;
    });

    return instance;
  }, [auth.accessToken]);

  React.useEffect(() => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    if (!window.gtag) {
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
    }

    initRudderstackAnalytics();
  }, []);

  const value = React.useMemo(
    () =>
      ({
        apiClient,
        featureFlags,
      } as IAppServices),
    [apiClient, featureFlags],
  );

  return (
    <AppServicesContext.Provider value={value}>
      {children}
    </AppServicesContext.Provider>
  );
};
